import Head from "expo-router/head";
import type { ReactNode } from "react";

/** Document `<head>` tags (title, meta, link) for a web page; the native variant renders nothing. */
export function DocumentHead({ children }: { children: ReactNode; }) {
  return <Head>{children}</Head>;
}
